export default function addLeadingZeroes(number = -1, places = 2) {
    let string = number.toString();
    const originalLength = string.length;
    for (let i = 0; i < (places - originalLength); i++) {
        string = '0' + string;
    }
    return string;
}
